module.exports = __webpack_public_path__ + "static/img/11areaA_03.8ab9254.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/通常使用/11areaA_03.png
// module id = 997
// module chunks = 1